window.addEventListener('load', function () {
    // load in all products
    var productsFound = [];
    var productsChecked = [];
    var activeFilters = [];
    $('.product-grid-card-new').each(function () {
        productsFound.push($(this));
    });

    const url = window.location.href;
    const urlParts = url.split('?');
    const base_url = urlParts[0];

    // Check & Strip Any Tracking Params Into Var
    var submittedParams = urlParts[1];
    var additionalParams = false;
    if (submittedParams) {
        var params = submittedParams.split('&');
        for (var i = 0; i < params.length; i++) {
            var param = params[i].split('=');
            if (isTrackingParam(param[0])) {
                (additionalParams) ? additionalParams += '&' + params[i] : additionalParams = params[i];
            }
        }
    }

    // Check querystring if it exists
    if (urlParts[1]) {
        parseURL();
    }
    checkFilters();

    // Sort function
    $('.collection-grid-filter-sort').on('change', function () {
        if ($(this).val() == 'title-ascending') {
            sortTitle($(this));
        }
        if ($(this).val() == 'title-descending') {
            sortTitle($(this));
        }
        if ($(this).val() == 'price-ascending') {
            sortPrice($(this));
        }
        if ($(this).val() == 'price-descending') {
            sortPrice($(this));
        }
    });

    // Open/Close filter tabs
    $('.filter--btn').on('click', function () {
        var element = $(this);
        var attribute = element.attr('data-filter-type');

        // if active tab is selected then close it
        if (element.hasClass('active')) {
            element.removeClass('active');
            $('.tabcontent').each(function () {
                if (!$(this).hasClass('hide')) {
                    $(this).addClass('hide');
                }
            });
            $('.filter--container button').each(function () {
                $(this).removeAttr('style');
            });
            return false;
        }

        // hide all divs
        $('.tabcontent').each(function () {
            if (!$(this).hasClass('hide')) {
                $(this).addClass('hide');
            }
        });

        // remove active class
        $('.filter--btn').each(function () {
            if ($(this).attr('data-filter-type') != attribute) {
                $(this).removeClass('active');
            }
        });

        // show specific filter div
        $('#filter--' + attribute).removeClass('hide');
        element.addClass('active');

        // add border bottom
        $('.filter--container button').each(function () {
            $(this).css('border-bottom', '0px');
        });
    });

    $('#filter--clear-filter').on('click', function () {
        clearAllFilters();
        highlightFilterImages(true);
    });

    const filterOptions = document.querySelectorAll('.filter--image-card');
    filterOptions.forEach(function (element) {
        element.addEventListener('click', function (e) {
            var attr = element.getAttribute('data-filter');
            var isFilter = $('#filter--type-' + attr).val();
            var newVal = null;
            if (isFilter == 1) {
                newVal = 0;
            } else {
                newVal = 1;
            }
            $('#filter--type-' + attr).val(newVal);
            var filterType = $(this).closest('.filter--image-card-container').attr('data-filter-list');
            checkFilters();
            highlightFilterImages(false, attr, filterType);
        });
    });

    // Sort functions

    function sortPrice($this) {
        var products = $('.product-grid-card-new');
        let productsShowing = $(".product-grid-card-show").length;

        if ($this.val() == 'price-ascending') {
            products.sort(function (a, b) { return $(a).data("product-price") - $(b).data("product-price") });
        }
        else {
            products.sort(function (a, b) { return $(b).data("product-price") - $(a).data("product-price") });
        }
        $(".collection-grid-container").empty();
        products.hide();
        products.removeClass('product-grid-card-show');
        $(products).each(function (i) {
            $(this).show();
            $(this).addClass('product-grid-card-show');
            if (i == productsShowing - 1) {
                return false;
            }
        });
        $(".collection-grid-container").html(products);
    }

    function sortTitle($this) {
        var products = $('.product-grid-card-new');
        let productsShowing = $(".product-grid-card-show").length;
        let productsNew = $('.product-grid-card-new');

        if ($this.val() == 'title-ascending') {
            productsNew = sortAlphaNumAsc(products);
        }
        else {
            productsNew = sortAlphaNumDsc(products);
        }

        $(".collection-grid-container").empty();
        productsNew.hide();
        productsNew.removeClass('product-grid-card-show');
        $(productsNew).each(function (i) {
            $(this).show();
            $(this).addClass('product-grid-card-show');
            if (i == productsShowing - 1) {
                return false;
            }
        });

        $(".collection-grid-container").html(productsNew);
    }

    function sortAlphaNumAsc(arr) {
        const sortByTitle = (a, b) => $(a).data("product-title").localeCompare($(b).data("product-title"), 'en', { numeric: true });
        return arr.sort(sortByTitle);
    }

    function sortAlphaNumDsc(arr) {
        const sortByTitle = (b, a) => $(a).data("product-title").localeCompare($(b).data("product-title"), 'en', { numeric: true });
        return arr.sort(sortByTitle);
    }

    // End of Sort functions

    // URL functions

    // Check For Tracking Param
    function isTrackingParam(paramName) {
        switch (paramName) {
            case 'utm_source': return true;
            case 'utm_medium': return true;
            case 'utm_campaign': return true;
            case 'utm_content': return true;
            case 'bis_id': return true;
            default: return false;
        }
    }

    function getUrl() {
        const urlParts = window.location.href.split('?');
        return {
            base: urlParts[0],
            queryString: urlParts[1]
        }
    }

    function parseURL() {
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);

        let typeCheck = urlParams.getAll('type');
        let materialCheck = urlParams.getAll('material');
        let colourCheck = urlParams.getAll('colour');
        let seatsCheck = urlParams.getAll('seats');
        let deliveryCheck = urlParams.getAll('delivery');
        let modelCheck = urlParams.getAll('model');


        let typeList = String(typeCheck).split(' ');
        let materialList = String(materialCheck).split(' ');
        let colourList = String(colourCheck).split(' ');
        let seatsList = String(seatsCheck).split(' ');
        let deliveryList = String(deliveryCheck).split(' ');
        let modelList = String(modelCheck).split(' ');

        clearAllFilters();

        $('.filter--image-card-container[data-filter-list="type"] .filter--image-card input').each(function () {
            if (typeList.indexOf($(this).attr('data-filter-input')) > -1) {
                $(this).val(1);
                $('.filter--container button[data-filter-type="type"] span.filter-active').removeClass('hide');
                if (!activeFilters.includes($(this).attr('data-filter-input'))) {
                    activeFilters.push($(this).attr('data-filter-input'));
                }
            }
        });

        $('.filter--image-card-container[data-filter-list="fabric"] .filter--image-card input').each(function () {
            if (materialList.indexOf($(this).attr('data-filter-input')) > -1) {
                $(this).val(1);
                $('.filter--container button[data-filter-type="fabric"] span.filter-active').removeClass('hide');
                if (!activeFilters.includes($(this).attr('data-filter-input'))) {
                    activeFilters.push($(this).attr('data-filter-input'));
                }
            }
        });

        $('.filter--image-card-container[data-filter-list="colour"] .filter--image-card input').each(function () {
            if (colourList.indexOf($(this).attr('data-filter-input')) > -1) {
                $(this).val(1);
                $('.filter--container button[data-filter-type="colour"] span.filter-active').removeClass('hide');
                if (!activeFilters.includes($(this).attr('data-filter-input'))) {
                    activeFilters.push($(this).attr('data-filter-input'));
                }
            }
        });

        $('.filter--image-card-container[data-filter-list="seats"] .filter--image-card input').each(function () {
            if (seatsList.indexOf($(this).attr('data-filter-input')) > -1) {
                $(this).val(1);
                $('.filter--container button[data-filter-type="seats"] span.filter-active').removeClass('hide');
                if (!activeFilters.includes($(this).attr('data-filter-input'))) {
                    activeFilters.push($(this).attr('data-filter-input'));
                }
            }
        });

        $('.filter--image-card-container[data-filter-list="delivery"] .filter--image-card input').each(function () {
            if (deliveryList.indexOf($(this).attr('data-filter-input')) > -1) {
                $(this).val(1);
                $('.filter--container button[data-filter-type="delivery"] span.filter-active').removeClass('hide');
                if (!activeFilters.includes($(this).attr('data-filter-input'))) {
                    activeFilters.push($(this).attr('data-filter-input'));
                }
            }
        });

        $('.filter--image-card-container[data-filter-list="model"] .filter--image-card input').each(function () {
            if (modelList.indexOf($(this).attr('data-filter-input')) > -1) {
                $(this).val(1);
                $('.filter--container button[data-filter-type="delivery"] span.filter-active').removeClass('hide');
                if (!activeFilters.includes($(this).attr('data-filter-input'))) {
                    activeFilters.push($(this).attr('data-filter-input'));
                }
            }
        });

        checkFilters();
        highlightFilterImages();
    }

    // End of URL functions

    // Product Functions

    function productsAmount() {
        let productsTotal = $('.product-grid-card-new').length;
        $('.collection-grid-filter-results-total').text(productsTotal);
    }


    function reload_js(src) {
        $('script[src="' + src + '"]').remove();
        $('<script>').attr('src', src).appendTo('head');
    }

    function checkFilters(ev) {

        var material = [];
        var colour = [];
        var seats = [];
        var type = [];
        var delivery = [];
        var model = [];

        // loop through hidden inputs and see if it's checked - change opacity if it isn't checked
        $('.filter--image-card-container[data-filter-list="type"] .filter--image-card input').each(function (index, item) {
            var isChecked = parseInt(item.value) == 1 ? true : false;
            if (isChecked) {
                var attribute = $(this).attr('data-filter-input');
                type.push(attribute);
            }
        });

        $('.filter--image-card-container[data-filter-list="fabric"] .filter--image-card input').each(function (index, item) {
            var isChecked = parseInt(item.value) == 1 ? true : false;
            if (isChecked) {
                var attribute = $(this).attr('data-filter-input');
                material.push(attribute);
            }
        });

        $('.filter--image-card-container[data-filter-list="colour"] .filter--image-card input').each(function (index, item) {
            var isChecked = parseInt(item.value) == 1 ? true : false;
            if (isChecked) {
                var attribute = $(this).attr('data-filter-input');
                colour.push(attribute);
            }
        });

        $('.filter--image-card-container[data-filter-list="seats"] .filter--image-card input').each(function (index, item) {
            var isChecked = parseInt(item.value) == 1 ? true : false;
            if (isChecked) {
                var attribute = $(this).attr('data-filter-input');
                if (!isNaN(attribute)) {
                    attribute = parseInt(attribute);
                }
                seats.push(attribute);
            }
        });

        $('.filter--image-card-container[data-filter-list="delivery"] .filter--image-card input').each(function (index, item) {
            var isChecked = parseInt(item.value) == 1 ? true : false;
            if (isChecked) {
                var attribute = $(this).attr('data-filter-input');
                if (!isNaN(attribute)) {
                    attribute = parseInt(attribute);
                }
                delivery.push(attribute);
            }
        });

        $('.filter--image-card-container[data-filter-list="model"] .filter--image-card input').each(function (index, item) {
            var isChecked = parseInt(item.value) == 1 ? true : false;
            if (isChecked) {
                var attribute = $(this).attr('data-filter-input');
                if (!isNaN(attribute)) {
                    attribute = parseInt(attribute);
                }
                model.push(attribute);
            }
        });

        // filter product
        productsChecked = [];

        if (material.length || colour.length || seats.length || type.length || delivery.length || model.length) {
            var searchArray = productsFound;
            $(searchArray).each(function () {
                var colourIndex = null;
                var materialIndex = null;
                var typeIndex = null;
                var deliveryIndex = null;
                var modelIndex = null;

                // if multiple types found then split string and check each colour
                if ($(this).data("product-type").indexOf(",") > -1) {
                    var types = $(this).data("product-type").split(",");
                    types.forEach(function (element) {
                        if (type.includes(element)) {
                            typeIndex = 1;
                        }
                    });
                } else {
                    typeIndex = type.indexOf($(this).data("product-type"));
                }

                // if multiple colours found then split string and check each colour
                if ($(this).data("product-colour").indexOf(",") > -1) {
                    var colours = $(this).data("product-colour").split(",");
                    colours.forEach(function (element) {
                        if (colour.includes(element)) {
                            colourIndex = 1;
                        }
                    });
                } else {
                    colourIndex = colour.indexOf($(this).data("product-colour"));
                }

                // if multiple material found then split string and check each colour
                if ($(this).data("product-material").indexOf(",") > -1) {
                    var materials = $(this).data("product-material").split(",");
                    materials.forEach(function (element) {
                        if (material.includes(element)) {
                            materialIndex = 1;
                        }
                    });
                } else {
                    materialIndex = material.indexOf($(this).data("product-material"));
                }

                if ($(this).data("product-delivery").indexOf(",") > -1) {
                    var deliveries = $(this).data("product-delivery").split(",");
                    deliveries.forEach(function (element) {
                        if (delivery.includes(element)) {
                            deliveryIndex = 1;
                        }
                    });
                } else {
                    deliveryIndex = delivery.indexOf($(this).data("product-delivery"));
                }

                if ($(this).data("product-model") && $(this).data("product-model").indexOf(",") > -1) {
                    var models = $(this).data("product-model").split(",");
                    models.forEach(function (element) {
                        if (model.includes(element)) {
                            modelIndex = 1;
                        }
                    });
                } else {
                    modelIndex = model.indexOf($(this).data("product-model"));
                }


                // if any matches found
                if (
                    (!type.length || (typeIndex > -1 && typeIndex !== null)) &&
                    (!material.length || (materialIndex > -1 && materialIndex !== null)) &&
                    (!colour.length || (colourIndex > -1 && colourIndex !== null)) &&
                    (!seats.length || seats.indexOf($(this).data("product-seats")) > -1) &&
                    (!delivery.length || (deliveryIndex > -1 && deliveryIndex !== null)) &&
                    (!model.length || (modelIndex > -1 && modelIndex !== null))
                ) {
                    productsChecked.push($(this));
                }
            });
        } else {
            // reset search
            $(productsFound).each(function () {
                productsChecked.push($(this));
            });
        }

        $('.collection-grid-container').empty();
        $('.collection-grid-container').html(productsChecked);

        var queryString = '?';
        var qsParts = [];

        if (type.length) {
            type.sort();
            qsParts.push('type=' + type.join('+'));
            $('.filter--container button[data-filter-type="type"] span.filter-active').removeClass('hide');
        } else {
            $('.filter--container button[data-filter-type="type"] span.filter-active').addClass('hide');
        }
        if (material.length) {
            material.sort();
            qsParts.push('material=' + material.join('+'));
            $('.filter--container button[data-filter-type="fabric"] span.filter-active').removeClass('hide');
        } else {
            $('.filter--container button[data-filter-type="fabric"] span.filter-active').addClass('hide');
        }
        if (colour.length) {
            colour.sort();
            qsParts.push('colour=' + colour.join('+'));
            $('.filter--container button[data-filter-type="colour"] span.filter-active').removeClass('hide');
        } else {
            $('.filter--container button[data-filter-type="colour"] span.filter-active').addClass('hide');
        }
        if (seats.length) {
            seats.sort();
            qsParts.push('seats=' + seats.join('+'));
            $('.filter--container button[data-filter-type="seats"] span.filter-active').removeClass('hide');
        } else {
            $('.filter--container button[data-filter-type="seats"] span.filter-active').addClass('hide');
        }

        if (delivery.length) {
            delivery.sort();
            qsParts.push('delivery=' + delivery.join('+'));
            $('.filter--container button[data-filter-type="delivery"] span.filter-active').removeClass('hide');
        } else {
            $('.filter--container button[data-filter-type="delivery"] span.filter-active').addClass('hide');
        }

        if (model.length) {
            model.sort();
            qsParts.push('model=' + model.join('+'));
            $('.filter--container button[data-filter-type="model"] span.filter-active').removeClass('hide');
        } else {
            $('.filter--container button[data-filter-type="model"] span.filter-active').addClass('hide');
        }

        queryString = qsParts.length ? queryString + qsParts.join('&') : '';

        // Set Tracking Params If Required
        if (additionalParams) {
            (queryString === '?' || queryString === '') ? queryString = '?' + additionalParams : queryString += '&' + additionalParams;
        }

        const currentUrl = getUrl();

        if ('?' + currentUrl.queryString !== queryString) {
            window.history.pushState({}, "", base_url + queryString);
        }
        loadMore();
        productsAmount();

        var sortVal = $('.collection-grid-filter-sort').val();
        if (sortVal) {
            if (sortVal == 'title-ascending') {
                sortTitle($('.collection-grid-filter-sort'));
            }
            if (sortVal == 'title-descending') {
                sortTitle($('.collection-grid-filter-sort'));
            }
            if (sortVal == 'price-ascending') {
                sortPrice($('.collection-grid-filter-sort'));
            }
            if (sortVal == 'price-descending') {
                sortPrice($('.collection-grid-filter-sort'));
            }
        }
    }

    // loop through different tabs and check which ones have been selected and change opacity and dynamically disable irrelevant filter options based on what is selected
    // if highlightAll set to true then opacity will be removed for all filter options
    function highlightFilterImages(highlightAll = false, attr = "", filterType = "") {
        if (highlightAll) {
            // remove opacity from all cards
            $('.filter--image-card-container .filter--image-card input').each(function () {
                $(this).parent().css('opacity', '');
                $(this).val(0);
            });
            // remove clear filter link
            $('#filter--clear-filter').addClass('hide');
        } else {
            // get list of filters that are available to selected filter (e.g. if armchair is selected then one seat should be the only available in size)
            var clearFilter = true;
            var availableMaterial = [];
            var availableColour = [];
            var availableSize = [];
            var availableType = [];
            var availableDelivery = [];
            var availableModel = [];

            $.each(productsChecked, function (index, item) {
                var elem = item[0];
                var material = $(elem).data('product-material');
                var type = $(elem).data('product-type');
                var colour = $(elem).data('product-colour');
                var size = $(elem).data('product-seats');
                var delivery = $(elem).data('product-delivery');
                var model = $(elem).data('product-model');

                var colourFound = false;
                if (colour.indexOf(",") > -1) {
                    var colours = colour.split(",");
                    colours.forEach(function (element) {
                        if (attr == element) {
                            colourFound = true;
                        }
                    });
                } else {
                    if (attr == colour) {
                        colourFound = true;
                    }
                }

                // add available filters to arrays
                if ((attr == material || activeFilters.includes(material)) ||
                    (attr == type || activeFilters.includes(type)) ||
                    (colourFound || activeFilters.includes(colour)) ||
                    (attr == size || activeFilters.includes(size)) ||
                    (attr == delivery || activeFilters.includes(delivery)) ||
                    (attr == model || activeFilters.includes(model))) {
                    if (!availableMaterial.includes(material)) {
                        availableMaterial.push(material);
                    }
                    if (!availableType.includes(type)) {
                        availableType.push(type);
                    }
                    var colours = colour.split(",");
                    if (colours.length > 0) {
                        $.each(colours, function (i, row) {
                            if (!availableColour.includes(row)) {
                                availableColour.push(row);
                                return;
                            }
                        });
                    } else {
                        if (!availableColour.includes(colour)) {
                            availableColour.push(colour);
                        }
                    }

                    // split if comma is found in delivery string, otherwise create array
                    if (delivery.includes(",")) {
                        var deliveries = delivery.split(",");
                    } else {
                        var deliveries = [delivery];
                    }
                    if (deliveries.length > 0) {
                        $.each(deliveries, function (i, row) {
                            if (!availableDelivery.includes(row)) {
                                availableDelivery.push(row);
                                return;
                            }
                        });
                    } else {
                        if (!availableDelivery.includes(delivery)) {
                            availableDelivery.push(delivery);
                        }
                    }

                    // split if comma is found in model string, otherwise create array
                    if (model.includes(",")) {
                        var models = model.split(",");
                    } else {
                        var models = [model];
                    }
                    if (models.length > 0) {
                        $.each(models, function (i, row) {
                            if (!availableModel.includes(row)) {
                                availableModel.push(row);
                                return;
                            }
                        });
                    } else {
                        if (!availableModel.includes(model)) {
                            availableModel.push(model);
                        }
                    }

                    if (!availableSize.includes(size.toString())) {
                        availableSize.push(size.toString());
                    }
                }
            });

            $('.filter--image-card-container .filter--image-card input').each(function (key, value) {
                var card = $(this).closest('.filter--image-card');
                var data = card.attr('data-filter');
                var filterList = card.closest('.filter--image-card-container').attr('data-filter-list');
                var isChecked = parseInt($(this).val()) == 1 ? true : false;
                if (!activeFilters.includes(data)) {
                    activeFilters.push(data);
                }

                if (isChecked) {
                    clearFilter = false;
                }
                if (availableMaterial.length ||
                    availableColour.length ||
                    availableSize.length ||
                    availableType.length ||
                    availableDelivery.length ||
                    availableModel.length) {
                    if (availableMaterial.includes(data) ||
                        availableType.includes(data) ||
                        availableSize.includes(data) ||
                        availableColour.includes(data) ||
                        availableDelivery.includes(data) ||
                        availableModel.includes(data)) { // available filters
                        card.css('opacity', '');
                        if (card.hasClass('selection-disabled')) {
                            card.removeClass('selection-disabled');
                        }
                    } else { // unavailable filters
                        if (!isChecked) {
                            card.css('opacity', '0.5');
                            if (filterType != filterList) { // dont disable anything within the same tab (unless already disabled)
                                if (!card.hasClass('selection-disabled')) {
                                    card.addClass('selection-disabled');
                                }
                            }
                        }
                    }
                }
            });

            if (clearFilter) {
                $('#filter--clear-filter').addClass('hide');
                clearAllFilters(false);
            } else {
                $('#filter--clear-filter').removeClass('hide');
            }
        }
    }

    function loadMore() {
        let size_li = $(".product-grid-card-new").length;
        var default_x_value = parseInt($('.product-load-more-container').data('number'));
        // let x = parseInt($('.product-load-more-container').data('number'));
        let x = 24;
        $('.product-grid-card-new').hide();
        $('.product-grid-card-new:lt(' + x + ')').show();
        $('.product-grid-card-new:lt(' + x + ')').addClass('product-grid-card-show');
        if (size_li <= 0) {
            $('.productLoadMore').hide();
            $('.productShowLess').hide();
        } else if (size_li <= default_x_value) {
            $('.productLoadMore').hide();
            $('.productShowLess').hide();
        }

        if (size_li > x && x > default_x_value) {
            $('.productLoadMore').show();
            $('.productShowLess').show();
        } else if (size_li > x && x == default_x_value) {
            $('.productLoadMore').show();
            $('.productShowLess').hide();
        } else if (size_li == x && x > default_x_value) {
            $('.productLoadMore').hide();
            $('.productShowLess').show();
        } else if (size_li == x && x == default_x_value) {
            $('.productLoadMore').hide();
            $('.productShowLess').hide();
        }

        $('.productLoadMore').click(function () {
            let size_li_show_more = $(".product-grid-card-new").length;
            let temp = parseInt(x) + parseInt(default_x_value);
            x = (temp <= size_li) ? temp : size_li;
            $('.product-grid-card-new:lt(' + x + ')').show();
            $('.product-grid-card-new:lt(' + x + ')').addClass('product-grid-card-show');
            $('.productShowLess').show();

            if (x == size_li_show_more) {
                $('.productLoadMore').hide();
            }
            productsAmount();
        });

        $('.productShowLess').click(function () {
            x = parseInt($('.product-load-more-container').data('number'));
            $('.product-grid-card-new').not(':lt(' + x + ')').hide();
            $('.product-grid-card-new').not(':lt(' + x + ')').removeClass('product-grid-card-show');
            $('.productLoadMore').show();
            $('.productShowLess').show();

            if (x <= parseInt($('.product-load-more-container').data('number'))) {
                $('.productShowLess').hide();
            }
            $('html,body').animate({
                scrollTop: $('.product-grid-card-new:nth-child(' + x + ')').offset().top
            }, 10);
            productsAmount();
        });
    }

    function clearAllFilters(hideContainer = true) {
        let filters = [
            'type',
            'fabric',
            'colour',
            'seats',
            'delivery',
            'model'
        ];
        // set all filters to zero
        filters.forEach(function (filter) {
            $(`.filter--image-card-container[data-filter-list="${filter}"] .filter--image-card input`).each(function () {
                $(this).val(0);
                $(`.filter--container button[data-filter-type="${filter}"] span.filter-active`).addClass('hide');
                if ($(this).parent().hasClass('selection-disabled')) {
                    $(this).parent().removeClass('selection-disabled');
                }
                $(this).parent().css('opacity', '');;
            });
        });

        // hide filter container
        if (hideContainer) {
            $('.filter--container button').each(function () {
                if ($(this).hasClass('active')) {
                } else {
                    var attr = $(this).attr('data-filter-type');
                    $(this).removeClass('active');
                    $('#filter--' + attr).addClass('hide');
                }
                $(this).removeAttr('style');
            });

            checkFilters();
        }
    }
    // End of Product functions
});
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}
var isNavigatedBack = performance.navigation.type === 2;
if (isNavigatedBack) {
    var pos = $('#shopify-section-filter-bar').offset().top;
    window.scrollTo(0, pos - 120);
}